/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Project Type" |
*
* @param {New_Project_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_label = /** @type {((inputs?: New_Project_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekttyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの種類")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de projeto")
	return /** @type {LocalizedString} */ ("Project Type")
});